import React from "react";

const numbersArray: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const ProductCategorySkeleton: React.FC = () => {
  return (
    <div className={`tw-w-[1200px] tw-mt-3`}>
      <div className={`tw-flex tw-space-x-16 tw-animate-pulse tw-w-16 tw-ml-5`}>
        <div className={`tw-flex-1 tw-space-y-2 tw-w-4`}>
          <div className={`tw-h-4 tw-bg-greyishBlue tw-rounded-none tw-col-span-5`} />
        </div>
      </div>
      <div className={` tw-mt-3 tw-flex tw-flex-wrap tw-animate-pulse`}>
        {numbersArray.map((item, index) => (
          <div key={index} className={`tw-ml-5 tw-mt-3 tw-rounded tw-flex-shrink-0 tw-box-border tw-w-[216px] tw-h-14 tw-flex tw-flex-row tw-py-3 tw-px-[19px] tw-items-center tw-justify-start tw-gap-[8px] tw-border-[1px] tw-border-solid tw-border-whitesmoke-400 tw-cursor-pointer hover:tw-bg-[#dee3f6]`}>
            <div className={`tw-flex tw-space-x-16`}>
              {/* <div className={`tw-rounded-full tw-bg-slate-500 tw-h-10 tw-w-10`}></div> */}
              <div className={`tw-flex-1 tw-space-y-6`}>
                <div className={`tw-space-y-3`}>
                  <div className={`tw-grid tw-grid-cols-1 tw-gap-4`}>
                    <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded-none tw-col-span-5`} />
                  </div>
                </div>
              </div>
              <div className={`tw-flex-1 tw-space-y-6`}>
                <div className={`tw-space-y-3`}>
                  <div className={`tw-grid tw-grid-cols-1 tw-gap-2`}>
                    <div className={`tw-h-2 tw-bg-greyishBlue tw-rounded-none tw-col-span-3`} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductCategorySkeleton;
